// extracted by mini-css-extract-plugin
export default {"root":"_1sR_Z"};